export type currencyOptions = {
  currency?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
};

export function formatAsCurrency(value?: number | null, options?: currencyOptions): string {
  if (value === null || value === undefined || isNaN(value)) {
    return '';
  }
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    ...options
  });
}
